import { AxiosRequestConfig } from 'axios';
import { TIMEOUT_URLS } from '../helpers/const';

/**
 * Middleware to apply specific timeouts to URLs.
 */
export const timeoutMiddleware = (config: AxiosRequestConfig): AxiosRequestConfig => {
  if (TIMEOUT_URLS.includes(config.url!)) {
    config.timeout = 10000;
  }

  return config;
};
